import React, { useState, useEffect } from 'react';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Alert from '@material-ui/lab/Alert';
import Typography from '@material-ui/core/Typography';
import Settings from './SettingsModal';

const Lobby = ({ settings, group, handleSubmit, loading, onSaveSettings }) => {
  const [showSetting, setShowSettings] = useState(false);

  const onSave = (s) => {
    setShowSettings(false);
    onSaveSettings(s);
  };

  return (
    <div>
      {group && (
        <Box marginBottom={3}>
          <Typography
            variant="h5"
            color="textPrimary"
            style={{ fontWeight: 'bold' }}
          >
            {group.name}
          </Typography>
          <Typography variant="body2" color="textSecondary">
            Group meeting
          </Typography>
        </Box>
      )}
      <Box marginBottom={2}>
        <Alert variant="filled" severity="success">
          Make sure to use latest version of Chrome/Firefox/Safari/Edge browser.
          <br />
          Use Chrome for best experience.
          <br />
          Please grant Camera & Microphone access when prompted.
        </Alert>
      </Box>
      <Button
        size="large"
        disabled={loading}
        variant="contained"
        color="primary"
        onClick={handleSubmit}
      >
        Join Video Call
      </Button>{' '}
      <Button
        size="large"
        variant="outlined"
        color="primary"
        onClick={() => setShowSettings(true)}
      >
        Settings
      </Button>
      {showSetting && (
        <Settings
          settings={settings}
          onSubmit={onSave}
          onClose={() => setShowSettings(false)}
        />
      )}
    </div>
  );
};

export default Lobby;
